const resolveFromSource = (source = {}, path = "") => {
  if (!source || typeof path !== "string" || !path) return undefined;

  if (Object.hasOwn(source, path)) return source[path];

  const tokens = path
    .replace(/\[(\d+)\]/g, ".$1")
    .split(".")
    .filter(Boolean);

  return tokens.reduce(
    (current, token) => (current == null ? undefined : current[token]),
    source
  );
};

export const getCompareMappings = (compareMappingsData = {}) => {
  const compareMappings =
    compareMappingsData?.items?.[0]?.fields?.compareMappings ||
    compareMappingsData?.fields?.compareMappings ||
    (Array.isArray(compareMappingsData)
      ? compareMappingsData?.[0]?.fields?.compareMappings ||
        compareMappingsData?.[0]?.compareMappings
      : undefined);

  if (!compareMappings || typeof compareMappings !== "object") return {};

  const cleanedMappings = {};
  for (const [label, path] of Object.entries(compareMappings)) {
    if (typeof path !== "string") continue;
    const trimmedPath = path.trim();
    if (trimmedPath) cleanedMappings[label] = trimmedPath;
  }

  return cleanedMappings;
};

export const mapCompareValues = (item = {}, mappings = {}) => {
  const sources = [item?.originalData || {}, item || {}];
  const mappedValues = {};

  for (const [label, path] of Object.entries(mappings)) {
    let mappedValue;
    for (const source of sources) {
      const value = resolveFromSource(source, path);
      if (value !== undefined && value !== null) {
        mappedValue = value;
        break;
      }
    }
    mappedValues[label] = mappedValue;
  }

  return mappedValues;
};
